module.exports = __webpack_public_path__ + "static/media/Email_Icon.f19168e4.svg";